var Student = "Studente";
var jobRole = {
	"Job role": "Ruolo lavorativo",
	"Academic / Researcher": "Settore accademico/Ricerca",
	"Advisor / Consultant": "Consulenze",
	"Business Executive": "Dirigente aziendale",
	"Developer / Engineer": "Sviluppatore/Ingegnere",
	"Entrepreneur (Founder/Co-Founder)": "Imprenditore (fondatore/co-fondatore)",
	"IT Executive": "Direttore IT",
	"IT Professional or Technical Manager": "Professionista informatico o responsabile tecnico",
	"Press / Media Analyst": "Stampa/Media Analyst",
	"Sales / Marketing": "Vendite/Marketing",
	Student: Student,
	"Solution or Systems Architect": "Architetto di soluzioni o sistemi",
	"System Administrator": "Amministratore di sistema",
	"Venture Capitalist": "Venture capitalist"
};

export { Student, jobRole as default };
